/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/referentiels-vehicule${buildQuery(params)}`, "GET"),

    getByType: async (type) => exeRequest(`/admin/referentiels-vehicule?type=${type}`, "GET"),

    getById: async (id) => exeRequest(`/admin/referentiels-vehicule/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/referentiels-vehicule`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/referentiels-vehicule/${id}`, "PUT", data),

    delete: async (id) => exeRequest(`/admin/referentiels-vehicule/${id}`, "DELETE"),

    seed: async (force) => exeRequest(`/admin/referentiels-vehicule/seed${force ? '?force=true' : ''}`, "POST"),
};
